export default "__VITE_ASSET__V$Q4JcVX__"